import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RagQA} from '../../services/ai/rag.service';

@Component({
    selector: 'app-rag-edit-dialog',
    templateUrl: './rag-edit-dialog.component.html',
    styleUrls: ['./rag-edit-dialog.component.scss']
})
export class RagEditDialogComponent {
    qaForm: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<RagEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RagQA,
        private fb: FormBuilder
    ) {
        this.qaForm = this.fb.group({
            id: [data.id],
            question: [data.question, [Validators.required, Validators.minLength(3)]],
            answer: [data.answer, [Validators.required, Validators.minLength(3)]],
            category: [data.category || ''],
            videoId: [data.videoId || '']
        });
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.qaForm.valid) {
            this.dialogRef.close(this.qaForm.value);
        }
    }
}